import React from 'react'
import style from "./Home.module.css"

const Line = () => {
  return (
    <div className={style.Line1}></div>
  )
}

export default Line